import { render, staticRenderFns } from "./carInner.vue?vue&type=template&id=4bd18ab9&scoped=true"
import script from "./carInner.vue?vue&type=script&lang=js"
export * from "./carInner.vue?vue&type=script&lang=js"
import style0 from "./carInner.vue?vue&type=style&index=0&id=4bd18ab9&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4bd18ab9",
  null
  
)

export default component.exports